import { render, staticRenderFns } from "./GoodsReceivedNote.vue?vue&type=template&id=ba5a6240"
import script from "./GoodsReceivedNote.vue?vue&type=script&lang=js"
export * from "./GoodsReceivedNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports